import { z } from "zod";

export enum RequestRecordTypeEnum {
    PARTNER = 1,
    POISTKA = 2,
    SKODA = 3,
}

export const RequestRecordTypeEnumSchema = z.nativeEnum(RequestRecordTypeEnum);
export type RequestRecordTypeEnumSchema = z.infer<typeof RequestRecordTypeEnumSchema>;